import common from './common.json';

const translation = { ...common };
export default translation;
